<template>
  <BaseMenu :with-offset="false">
    <BaseButton size="xs" theme="white" class="!p-1 text-gray-700">
      <BaseIcon name="outline_dots_horizontal" />
    </BaseButton>

    <template #menu>
      <div class="rounded-xl w-42 bg-white shadow-lg py-2">
        <BaseButton
          v-for="menuItem in menuList"
          :key="menuItem.text"
          theme="white"
          class="w-full !text-gray-900"
          rounded="none"
          justify="start"
          :disabled="isProcessing"
          @click="menuItem.action"
        >
          <BaseIcon
            v-if="menuItem.icon"
            :name="menuItem.icon"
            class="flex-shrink-0 mr-3"
            size="xs"
          />
          {{ menuItem.text }}
        </BaseButton>
      </div>
    </template>
  </BaseMenu>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { copyLink } = useClipboardCopy()

interface MenuItem {
  text: string
  action: () => void
  icon?: string
}

interface PropsInterface {
  menu?: MenuItem[]
  pageLink?: string
  isCopyLink?: boolean
  isProcessing?: boolean
}

const props = withDefaults(defineProps<PropsInterface>(), {
  menu: () => [],
  isCopyLink: true,
  pageLink: '',
  isProcessing: false,
})

const copyLinkMenuItem: MenuItem = {
  icon: 'outline_link',
  text: t('common.copy_link'),
  action: () => copyLink(props.pageLink),
}

const menuList: ComputedRef<MenuItem[]> = computed(() =>
  props.isCopyLink ? [...props.menu, copyLinkMenuItem] : props.menu
)
</script>
